import { Base } from 'src/app/shared/model/security/base.model';
import { Persona } from 'src/app/shared/model/persona/persona';
import { Credito } from './credito';

export class PersonaCredito extends Base{
    id: number;
    persona: Persona;
    credito: Credito;
    numIntegrante:number;
    comprobante:string;
    entregado:boolean;
    monto: number;
    montoSolicitado: number = 0;
    montoPendiente: number = 0;
    comisionAper: number = 0;
}
